import httpCommerce from './httpCommerce'
import { getToken } from '@vue/services/jwt.service'

export const getCartLegacy = async () => {
  return httpCommerce.get('/api/cart', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const getCart = async () => {
  return httpCommerce.get('/cart', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const recreatewebcart = async id => {   
  return httpCommerce.get(`/api/cart/recreatewebcart?id=${id}`, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const getsitesettings = async id => {   
  return httpCommerce.get(`/api/sites/getsitesettings?id=${id}`, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const createCart = async params => {
  return httpCommerce.post('/cart', 
    params,
    {
      headers: {
        Authorization: `bearer ${await getToken()}`
      }
    }
  )
}

export const addLine = async params => {
  return httpCommerce.post(
    '/api/cart/add',
    {
      currencyCode: params.currencyCode,
      qty: params.qty
    },
    {
      headers: {
        Authorization: `bearer ${await getToken()}`
      }
    }
  )
}

export const isBuyBack = async buyback => {
  return httpCommerce.get(`/api/cart/buyback?isBuyBack=${buyback}`, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const isRefund = async refund => {
  return httpCommerce.get(`/api/cart/refund?isRefund=${refund}`, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const updateLine = async (id, params) => {
  return httpCommerce.put(`/api/cart/line/${id}`, params, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const deleteLine = async id => {
  return httpCommerce.delete(`/api/cart/line/${id}`, {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export const deleteCart = async () => {
  return httpCommerce.delete('/cart', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export default {
  getCartLegacy,
  getCart,
  createCart,
  addLine,
  updateLine,
  deleteLine,
  recreatewebcart,
  getsitesettings,
  deleteCart
}
